import {
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useGetRefferalSalesPersons } from "../../hooks/licensemanager/useRefferalSalesPersons";
//  import { useTranslation } from "react-i18next";

type DisplayRefferalSalesPersonsDropDownProps = {

  callbackFn: any;
};

export const DisplayRefferalSalesPersonsDropDown: React.FC<
  DisplayRefferalSalesPersonsDropDownProps
> = ({ callbackFn }) => {
  const { t } = useTranslation();
  const refferalSalesPersons = useGetRefferalSalesPersons()
  return (
    <>
      <SelectField
        name="affiliate_code"
        label={t("licenses.basic.search.refferal_sales_person.title")}
        options={(refferalSalesPersons?.data?.list ?? []).map(
          (refferalSalesPerson: any) => {
            return {
              label: refferalSalesPerson.name!,

              value: refferalSalesPerson.code!,
              refferalSalesPerson: refferalSalesPerson,
            };
          }
        )}
        showSearch
        optionFilterProp="label"
        onChange={(value, refferalSalesPerson) => callbackFn(value, refferalSalesPerson)}
      />
    </>
  );
};
